// extracted by mini-css-extract-plugin
export default {"dimLayer":"KJ3Wrnd3tb4OvBgVOcDz"};